import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsService } from '../services/news.service';
import * as $ from 'jquery'

@Component({
  selector: 'app-specific-tag',
  templateUrl: './specific-tag.component.html',
  styleUrls: ['./specific-tag.component.css']
})
export class SpecificTagComponent implements OnInit {

  @Input("tagName")tagName:string  ;
   newsData  ; myDataArray:any[]  = [] ; myData:any[] = []

  constructor(private _Activatedroute:ActivatedRoute , private _Router:Router , private newData:NewsService) 
  { 
    this.myDataArray = []
    this.myData=[]
    this._Activatedroute.params.subscribe(params => {
      this.tagName = params['name'];
      // reset and set based on new parameter this time
      });
   
   this.newsData = this.newData.newsData ;
   for(let item of this.newsData)
   {
     for(let tag of item.tags)
     {
       if(tag == this.tagName)
       {
         this.myDataArray.push(item) 
         break
       }
      
     }
   }
   this.myData = this.myDataArray
 
  }

  ngOnInit() {

   

    this._Activatedroute.params.subscribe (res => {
      this.tagName = res['name'] ; 
      this.newsData = this.newData.newsData ;
     
      this.myDataArray = []
      this.myData = []
      for(let item of this.newsData)
      {
        for(let tag of item.tags)
        {
          if(tag === this.tagName)
          {
            this.myDataArray.push(item) 
            break
          }
        
        }
      }
     this.myData = this.myDataArray

   
    }); 



    $(document).ready(function(){

      $("body").on("click",".accor li",function(){

        if($(this).attr("id") == "1")
        {
         $(".firs").css("display","block");
          $(".sec").css("display","none");  
           $(this).addClass("act");
           $(this).siblings().removeClass("act"); 
        }
        else{
          $(".sec").css("display","block");
          $(".firs").css("display","none"); 
          $(this).addClass("act");
           $(this).siblings().removeClass("act");
        }

      });
        
        });

  }
  changeURL(tag)
  {
    
    this._Router.navigate(["News/Tag",tag])
  }
  changeWritter(author)
  {
    this._Router.navigate(["News/Writter",author])
  }

}
